import { useEffect, useCallback } from 'react';

import { useAuthContext } from '../../Auth/context';

import ACTIONS_TYPES from './actionTypes';

const useInitFetch = ({ state, dispatch, bookingId, getBooking }) => {
  const { state: { user } } = useAuthContext();

  const handleBookingFetch = useCallback(() => {
    dispatch({ type: ACTIONS_TYPES.UPDATE_STATUS, status: 'loading' });
    getBooking(bookingId)
      .then((data = {}) => {
        if (['OFFER_CORRUPTED', 'NoOfferFound'].includes(data.message)) {
          return dispatch({ type: ACTIONS_TYPES.SET_EXPIRED });
        }

        if (data && !!data.id) dispatch({
          type: ACTIONS_TYPES.SET_BOOKING, booking: data, user
        });
        else dispatch({ types: ACTIONS_TYPES.SET_EXPIRED });
      }).catch(() => dispatch({
        type: ACTIONS_TYPES.ALERT_ERROR,
        error: 'ثمة مشكلة ما!'
      }));
  }, [bookingId]);

  useEffect(() => {
    if (state.status === 'initial') {
      handleBookingFetch();
    }
  }, [state, handleBookingFetch]);

  return {};
};

export default useInitFetch;